import React, { useMemo } from "react";
import { RouteGuard } from "./RouteGuard";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Memoize config to prevent unnecessary re-renders
  const config = useMemo(() => ({
    requireAuth: true,
    redirectTo: "/",
    redirectToOnboardingIfNeeded: true,
  }), []);

  return (
    <RouteGuard config={config}>
      {children}
    </RouteGuard>
  );
};
